import React, { useState, useEffect, useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../common/SearchBar";
import { handleCameraSearchAutoAdd } from "./CameraAutoAddUtils/handleCameraSearchAutoAdd";
import { useCameraAutoAddStore } from "./CameraAutoAddStore/cameraAutoAddStore";

export const AutoAddSearchBar = ({
  setCamerasList,
  setCamerasObject,
  navigate,
  productsArray,
  setCheckboxesChecked,
  checkboxesChecked,
}: {
  setCamerasList: any;
  setCamerasObject: any;
  navigate: any;
  productsArray: any[];
  setCheckboxesChecked: any;
  checkboxesChecked: any;
}) => {
  const [inputValue, setInputValue] = useState("");
  const currentSearchRef = useRef<string>("");

  const { setSearchingCameras } = useCameraAutoAddStore();

  useEffect(() => {
    // Update the current search ref
    currentSearchRef.current = inputValue;

    const timer = setTimeout(() => {
      // Only proceed if the input value hasn't changed
      if (currentSearchRef.current === inputValue) {
        handleCameraSearchAutoAdd(
          setCamerasList,
          setCamerasObject,
          inputValue,
          navigate,
          productsArray,
          setCheckboxesChecked,
          checkboxesChecked,
          currentSearchRef
        );
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [
    inputValue,
    setCamerasList,
    setCamerasObject,
    navigate,
    productsArray,
    setCheckboxesChecked,
  ]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchingCameras(true);
    setInputValue(event.target.value);
  };

  return (
    <Search sx={{ width: 150 }}>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <StyledInputBase
        value={inputValue}
        placeholder="Search Cameras..."
        onChange={handleChange}
        inputProps={{ "aria-label": "search" }}
      />
    </Search>
  );
};
